import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useAtom } from "jotai";
import type { JSX } from "react";

import { FormTextAreaQuestion } from "@/components/onboarding/form-text-area-question";
import { consultingAtom } from "@/lib/atoms/consulting-atom";

const ConsultingCaptacaoPage = (): JSX.Element => {
  const navigate = useNavigate();
  const [form, setForm] = useAtom(consultingAtom);

  const handleChange = (value: string): void => {
    setForm((prev) => ({ ...prev, captacao: value }));
  };

  const handleContinue = (): void => {
    void navigate({ to: "/onboarding/consulting/expectation" });
  };

  return (
    <FormTextAreaQuestion
      title="Conte brevemente sua jornada para captar pacientes até hoje"
      subtitle="O que tentou fazer, o que sentiu que deu algum resultado e qual foi sua principal dificuldade nesse processo?"
      progress={0.7}
      value={form.captacao}
      onChange={handleChange}
      onContinue={handleContinue}
      metadataTranscriptionTracking={{ feature: "consultoria" }}
    />
  );
};

export const Route = createFileRoute("/onboarding/consulting/acquisition")({
  component: ConsultingCaptacaoPage,
});
